export default __webpack_public_path__ + "static/dizions-ISO-27001-2013-icon-80728eeb3580b08e5146c3406a8ab8d7.png";